import React from 'react'
import { Box, Toolbar, Typography } from "@mui/material";
import { useLanguage } from '../context/LanguageContext';
import Terms from '../Component/Terms';
import Header from "../Component/header";
import DesktopFooter from "../Component/Desktopfooter";
import Footer from '../Component/Footer';
const Termspage = () => {
    const { t } = useLanguage();
    return (
        <>
            <div className='text-Wrapper'>
              <Header/>
                <Box>
                    <Toolbar>
                        <Terms />
                    </Toolbar>
                </Box>
            </div>
             <DesktopFooter/>
            <Footer />
        </>
    )
}

export default Termspage